import { useMemo } from 'react';

import { UsePrintty } from '../types';
import { usePdf } from './usePdf';
import { usePrint } from './usePrint';

/** Combines usePrint and usePdf for cases where dynamic actions are needed */
const usePrintty = ({ pdfAction, ...rest }: UsePrintty & { pdfAction: 'print' | 'download' }) => {
  const printObject = usePrint(rest);
  const pdfObject = usePdf(rest);

  const chosenObject = useMemo(
    () => (pdfAction == 'print' ? printObject : pdfObject),
    [pdfAction, pdfObject, printObject]
  );
  const action = useMemo(() => {
    return pdfAction == 'print' ? printObject.print : pdfObject.savePdf;
  }, [pdfAction, printObject.print, pdfObject.savePdf]);

  return {
    action,
    ...chosenObject,
  };
};

export { usePrintty };
